module.exports = __webpack_public_path__ + "img/rank-bg.a5fb69f9.png";